import React, { FC } from 'react';

import { CSSTransition } from 'react-transition-group';

import { Stats } from '../Stats';
import { NumberPicker } from './Components/NumberPicker';

export interface IProps {
  onChange?: (newValue: number) => void;
  gross?: number;
  net?: number;
  par: number;
  editMode: boolean;
  empty: boolean;
  notSaved?: boolean;
  disabled: boolean;
}

const ScorePicker: FC<IProps> = props => {
  const { par, gross, net, editMode, onChange, empty, disabled, notSaved } = props;

  return (
    <div className="css-animation">
      <CSSTransition
        in={!editMode && !disabled}
        timeout={500}
        classNames="fade"
        unmountOnExit={true}
      >
        <Stats gross={empty ? undefined : gross} net={empty ? undefined : net} />
      </CSSTransition>

      <CSSTransition in={editMode} timeout={500} classNames="fade" unmountOnExit={true}>
        <NumberPicker
          disabled={disabled && !notSaved}
          defaultValue={par}
          value={gross || par}
          onChange={onChange}
        />
      </CSSTransition>
    </div>
  );
};

export default ScorePicker;
